import "./IssuesPage.scss";
import IssuesPage from "./IssuesPage";

export { default as IssuesListItem } from "./IssuesListItem";
export { default as IssuesGridItem } from "./IssuesGridItem";

export default IssuesPage;

